import { Send, Mic, MicOff, Square } from "lucide-react";

export const ChatComposer = ({
  input, onInputChange, onSend, voiceSupported, listening, recording, onMicClick, sending,
}) => {
  const micActive = listening || recording;
  const renderMicIcon = () => {
    if (!voiceSupported) return recording ? <Square className="w-5 h-5" /> : <Mic className="w-5 h-5" />;
    return micActive ? <Mic className="w-5 h-5" /> : <MicOff className="w-5 h-5" />;
  };

  return (
    <div className="p-4 md:p-6 w-full max-w-3xl mx-auto">
      <div className="flex items-center gap-3">
        <div className="flex-1 relative">
          <input
            data-testid="chat-input-field"
            value={input}
            onChange={(e) => onInputChange(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && onSend()}
            placeholder="Escribe un mensaje para Kai..."
            disabled={sending || recording}
            className="w-full bg-black/40 border border-white/10 rounded-full pl-6 pr-14 py-4 focus:outline-none focus:ring-1 focus:ring-cyan-500/50 focus:border-cyan-500/50 backdrop-blur-md transition-all text-slate-200 placeholder:text-slate-500 disabled:opacity-60"
          />
          <button
            data-testid="send-button"
            onClick={onSend}
            disabled={sending || !input.trim()}
            className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-cyan-500/90 hover:bg-cyan-400 text-slate-950 flex items-center justify-center transition-all disabled:opacity-40 active:scale-95"
          >
            <Send className="w-4 h-4" />
          </button>
        </div>

        <button
          data-testid="voice-input-btn"
          onClick={onMicClick}
          disabled={sending}
          className={`w-14 h-14 rounded-full border flex items-center justify-center transition-all shrink-0 ${
            micActive
              ? "bg-cyan-500/20 text-cyan-300 border-cyan-400 shadow-[0_0_30px_rgba(34,211,238,0.6)] animate-pulse"
              : "border-cyan-500/30 text-cyan-400 hover:border-cyan-400 hover:shadow-[0_0_15px_rgba(34,211,238,0.5)]"
          } disabled:opacity-40`}
        >
          {renderMicIcon()}
        </button>
      </div>
      {voiceSupported ? (
        <p className="text-center text-[11px] font-mono mt-3 text-slate-500" data-testid="voice-status">
          {listening ? "Kai te está escuchando — habla cuando quieras" : "Micrófono en pausa"}
        </p>
      ) : (
        <p className="text-center text-[11px] font-mono mt-3 text-slate-600">
          Pulsa el micrófono para hablar (tu navegador no admite escucha continua)
        </p>
      )}
    </div>
  );
};
